export const routes = {
  /*[ USER ROUTES ]*/
  getUserInformation: 'onboarding-service/customer/userName',

  /*[ LOAN ROUTES ]*/
  getDetailsCredit: 'loan/loan/getDetailsCredit/',
  credit: 'private/credit',

  /*[ LOANAPPLICATION ROUTES ]*/
  DataValidationService: 'loanapplication-management-service/data-confirmation/execute',
  productValidationsStartWorkFlow: 'loanapplication-management-service/initial-product/execute',

  sanitizeFields: 'loanapplication-management-service/data-confirmation/verify-fields',

  /*[ DECISION MODEL ROUTES ]*/
  initialValidations: 'decision/identity-validations/execute/v1/initial/validation',
  decisionModelValidations: 'decision/decision-model/execute',
  finalValidations: 'decision/identity-validations/execute/v1/final/validation',
  counterOfferProcess: 'decision/counteroffer/process/{accept}',
  counterOfferResponse: 'decision/counteroffer/get_counteroffer_response',
  confirmDateOfIssue: 'decision/decision-model/execute/document-issue',

  /*[ DISPERSION METHOD ROUTES ]*/
  getAllBanks: 'back-dispersion-method/private/dispersion/v1/get-all-banks',

  /*[ ONBOARDING ROUTES ]*/
  createAditionalDataInCustomerUrl: 'onboarding-service/customer/additional-info',
  getList: 'onboarding-service/list/',
  getCities: 'onboarding-service/list/locations/find',
  saveTermsConditions: 'onboarding-service/customer/accept-terms',

  /*[ORIGINATION ROUTES]*/
  originationParametersByKey: 'origination/system/onr-parameter/{key}',
  originationParametersByKeyAndGroup: 'origination/system/onr-parameter/{key}/{group}',

  /*[ OTHERS ]*/
  sendPetition: 'petition',

  /*[BACK-DEBT]*/
  verifyLoanNovation: 'verify/loan/novation',

  /*[CARD]*/
  activeCard: 'back-card-management/v1/card/info',
  updateCardStatus: 'back-card-management/v1/card/status/update',
};
